import { TableColumn, TableData } from '@billy/design-system'
import { Text } from '@react-pdf/renderer'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Currency } from '../../../../../../../../../../../../types/currency'
import { LocaleIdentifier } from '../../../../../../../../../../../../types/localeIdentifier'
import { getCellDisplayValue } from '../../../../utils/getCellDisplayValue'
import { SalesReportPdfTableRow } from '../SalesReportPdfTableRow'
import { getTableRowCellPdfStyles } from './utils/getTableRowCellPdfStyles'

interface SalesReportPdfTableContentProps<T extends TableData> {
  currency: Currency
  locale: LocaleIdentifier
  tableColumns: TableColumn<T>[]
  tableData: T[]
}

export const SalesReportPdfTableContent = <T extends TableData>({
  currency,
  locale,
  tableColumns,
  tableData,
}: SalesReportPdfTableContentProps<T>): ReactElement => {
  const { t } = useTranslation()

  return (
    <>
      {tableData.map((row, rowIndex) => (
        <SalesReportPdfTableRow key={rowIndex}>
          {tableColumns.map((column, columnIndex) => {
            const isLastColumn = columnIndex === tableColumns.length - 1
            const displayValue = getCellDisplayValue({ column, currency, locale, row, t })
            const tableRowCellPdfStyles = getTableRowCellPdfStyles({
              minWidth: column.minWidth,
              shouldHaveLastColumnStyles: isLastColumn,
            })

            return (
              <Text key={columnIndex} style={tableRowCellPdfStyles}>
                {displayValue}
              </Text>
            )
          })}
        </SalesReportPdfTableRow>
      ))}
    </>
  )
}
